var _circle, _path, _circle2, _path2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#EEEEEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9404 6C16.3808 6.00021 16.7687 6.28856 16.8965 6.70996L17.2881 8H19C20.6569 8 22 9.34315 22 11V18C22 19.6569 20.6569 21 19 21H9C7.34315 21 6 19.6569 6 18V11C6 9.34315 7.34315 8 9 8H10.7119L11.1035 6.70996C11.2313 6.28856 11.6192 6.00021 12.0596 6H15.9404ZM14 10C11.7909 10 10 11.7909 10 14C10 16.2091 11.7909 18 14 18C16.2091 18 18 16.2091 18 14C18 11.7909 16.2091 10 14 10Z",
    fill: "#B3BEC4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 3,
    fill: "#B3BEC4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0469 6C15.4344 6.00007 15.7874 6.2244 15.9521 6.5752L16.6211 8H19C20.6569 8 22 9.34315 22 11V18C22 19.6569 20.6569 21 19 21H9C7.34315 21 6 19.6569 6 18V11C6 9.34315 7.34315 8 9 8H11.3789L12.0479 6.5752C12.2126 6.2244 12.5656 6.00007 12.9531 6H15.0469ZM14 10C11.7909 10 10 11.7909 10 14C10 16.2091 11.7909 18 14 18C16.2091 18 18 16.2091 18 14C18 11.7909 16.2091 10 14 10Z",
    fill: "#B3BEC4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 3,
    fill: "#B3BEC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCamera);
export default __webpack_public_path__ + "static/media/profileCamera.74138b56d6f6e95c372f5b0db3bc0889.svg";
export { ForwardRef as ReactComponent };